var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"tw-w-full tw-h-full tw-object-fit",attrs:{"src":_vm.pictureUrl}})}
var staticRenderFns = []

export { render, staticRenderFns }